import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GoldInvestModalState {
  isOpen: boolean;
  amount?: number | null;
  tenure?: number | null;
  src?: string | null;
}

interface ModalPayload {
  isOpen: boolean;
  amount?: number | null;
  tenure?: number | null;
  src?: string | null;
}

const initialState: GoldInvestModalState = {
  isOpen: false,
  amount: null,
  tenure: null,
  src: null,
};

const goldInvestModalSlice = createSlice({
  name: "goldInvestModal",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<{ amount?: number; tenure?: number; src?: string } | undefined>) => {
      state.isOpen = true;

      if (action?.payload?.amount !== undefined) {
        state.amount = action.payload.amount;
      }

      if (action?.payload?.tenure !== undefined) {
        state.tenure = action.payload.tenure;
      }

      if (action?.payload?.src !== undefined) {
        state.src = action.payload.src;
      }
    },

    closeModal: (state) => {
      state.isOpen = false;
      state.amount = null;
      state.tenure = null;
      state.src = null;
    },

    setModal: (state, action: PayloadAction<ModalPayload>) => {
      state.isOpen = action.payload.isOpen;

      if (action.payload.amount !== undefined) {
        state.amount = action.payload.amount;
      }

      if (action.payload.tenure !== undefined) {
        state.tenure = action.payload.tenure;
      }

      if (action.payload.src !== undefined) {
        state.src = action.payload.src;
      }
    },
  },
});

export const { openModal, closeModal, setModal } = goldInvestModalSlice.actions;
export default goldInvestModalSlice.reducer;
